module.exports = __webpack_public_path__ + "media/customizations/sunterra/back-8eed22e36306ad20ef8b9f887cf46c77.jpg";